<div id="header-profile">
  <mat-accordion displayMode="flat">
    <mat-expansion-panel [disabled]="true" class="header-profile-expansion-panel mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'100px'">
        <app-user-personal-information></app-user-personal-information>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel class="header-profile-expansion-panel configuration-panel mat-elevation-z0" id="lblConfiguration">
      <mat-expansion-panel-header (click)="$event.stopPropagation();">
        <mat-panel-title id="pnlConfigurationTitle">
          <span>{{ 'titleConfiguration.TITLE' | translate }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-nav-list>
        <mat-list-item class="disabled" *ngFor="let option of 'optionMyProfile.TITLE' | translate">
          <a>
            <span class="disabled" mat-line>
              <mat-icon mat-list-icon>lens</mat-icon>
              {{option}}
            </span>
          </a>
        </mat-list-item>
        <mat-list-item id="submenus-container" *ngIf="canChangeManager" (click)="changeManager()">
          <a id="change-manager-anchor" href="Javascript:void(0)" >
            <span mat-line>
                {{ 'titleChangeManager.TITLE' | translate}}
            </span>
          </a>
        </mat-list-item>
      </mat-nav-list>
      <div id="header-profile-language">
        <span mat-line>{{ 'titleLanguage.TITLE' | translate}}</span>&nbsp;
        <img src="./assets/img/flag_br.svg" id="languageFlagBR" class="icon-flag" alt="Português"
          [ngClass]="{'border-flag' : languageIsBR}" (click)="changeSiteLanguage($event, 'br')">
        <img src="./assets/img/flag_es.svg" id="languageFlagES" class="icon-flag" alt="Español"
          [ngClass]="{'border-flag' : languageIsES}" (click)="changeSiteLanguage($event, 'es')" class="es-header-profile-language">
        <img src="./assets/img/flag_us.png" id="languageFlagUS" class="icon-flag" alt="English"
          [ngClass]="{'border-flag' : languageIsUS}" (click)="changeSiteLanguage($event, 'us')">
      </div>
    </mat-expansion-panel>
    <button id="btnSair" class="exit-button" (click)="logout()">
      <span>{{ 'titleExit.TITLE' | translate }}</span>
    </button>
  </mat-accordion>
</div>